const data = [
	{
		id: 1,
		image: "https://rukminim1.flixcart.com/image/312/312/kgiaykw0/mobile/9/q/m/apple-iphone-11-mhdg3hn-a-original-imafwqepdx2mfnuz.jpeg?q=100",
		name: "APPLE iphone 11",
		price: 51999,
		dis: "Dual-camera system with Ultra Wide. Night mode and stunning video quality. Water and dust resistance.1 Long-lasting battery life.2 In six stunning colors. Experience iPhone at 11.",
		rate: { star: "4.5", rating: "2,13,992", review: "3,644" },
		about: ["128 GB ROM", "13.67 cm (5.9 inch) Retina HD Display", "12MP Rear Camera | 7MP Front Camera", "A13 Bionic Chip with 3rd Gen Neural Engine Processor"],
	},
	{
		id: 2,
		image: "https://rukminim1.flixcart.com/image/312/312/kg8avm80/mobile/y/7/n/apple-iphone-12-dummyapplefsn-original-imafwg8dqq7z8cgh.jpeg?q=70",
		name: "APPLE iphone 12",
		price: 71999,
		dis: "It’s a leap year. A14 Bionic rockets past every other smartphone chip. The Pro camera system takes low-light photography to the next level — with an even bigger jump on iPhone 12 Pro Max. And Ceramic Shield delivers four times better drop performance. Let’s see what this thing can do.",
		rate: { star: "4.7", rating: "1,24,742", review: "10,644" },
		about: ["128 GB ROM", "16.12 cm (6.2 inch) Retina HD Display", "12MP Rear Camera | 7MP Front Camera", "A14 Bionic Chip with 4th Gen Neural Engine Processor"],
	},

	{
		id: 3,
		image: "https://rukminim1.flixcart.com/image/312/312/k9loccw0/mobile/p/z/q/apple-iphone-se-mxd02hn-a-original-imafrcpjfehbbqgb.jpeg?q=70",
		name: "APPLE iphone SE",
		price: 34999,
		dis: "Say “Alexa” to play music, make calls, ask questions, control smart devices and more using just your voice. Download the Alexa app on your OnePlus 8 to start using Alexa hands-free today.",
		rate: { star: "4.2", rating: "1,13,742", review: "9,644" },
		about: ["128 GB ROM", "11.94 cm (4.7 inch) Retina HD Display", "12MP Rear Camera | 7MP Front Camera", "A13 Bionic Chip with 3rd Gen Neural Engine Processor"],
	},
	{
		id: 4,
		image: "https://rukminim1.flixcart.com/image/312/312/jsdj8nk0/mobile/u/p/f/samsung-galaxy-s10-plus-sm-g975fcwhins-original-imafdys4qx4fgshc.jpeg?q=70",
		name: "SAMSUNG Galaxy s10 plus",
		price: 34999,
		dis: "Say “Alexa” to play music, make calls, ask questions, control smart devices and more using just your voice. Download the Alexa app on your OnePlus 8 to start using Alexa hands-free today.",
		rate: { star: "4.4", rating: "1,13,742", review: "9,644" },
		about: ["1 TB ROM", "16.3 cm (6.4 inch) Retina HD Display", "16MP + 12MP Rear Camera | 10MP + 8MP Front Camera", "Exynos 9 9820 Processor"],
	},
	{
		id: 5,
		image: "https://rukminim1.flixcart.com/image/312/312/kjvrdzk0/mobile/y/n/z/samsung-galaxy-s21-ultra-sm-g998bzsginu-original-imafzchbfk4zg9ga.jpeg?q=70",
		name: "SAMSUNG Galaxy S21 Ultra ",
		price: 105999,
		dis: "Say “Alexa” to play music, make calls, ask questions, control smart devices and more using just your voice. Download the Alexa app on your OnePlus 8 to start using Alexa hands-free today.",
		rate: { star: "4.9", rating: "2,13,742", review: "9,644" },
		about: ["128 GB ROM", "17.27 cm (6.8 inch) Retina HD Display", "108MP + 12MP  Rear Camera | 7MP Front Camera", "Exynos 2100 Processor"],
	},
	{
		id: 6,
		image: "https://rukminim1.flixcart.com/image/312/312/knoxnrk0/mobile/s/d/d/g40-fusion-panv0002in-panv0006in-panv0010in-motorola-original-imag2aqcxrhhuwfh.jpeg?q=70",
		name: "MOTOROLA G40 Fusion",
		price: 16499,
		dis: "Say “Alexa” to play music, make calls, ask questions, control smart devices and more using just your voice. Download the Alexa app on your OnePlus 8 to start using Alexa hands-free today.",
		rate: { star: "4.3", rating: "13,742", review: "1,644" },
		about: ["128 GB ROM", "17.22 cm (6.78 inch)  Full HD Display", "64MP + 8MP + 2MP  Rear Camera |  16MP Front Camera", "Qualcomm Snapdragon 732G Processor"],
	},
];

export default data;
